import { render, staticRenderFns } from "./SpeditorClaim.vue?vue&type=template&id=061e3931&"
import script from "./SpeditorClaim.vue?vue&type=script&lang=js&"
export * from "./SpeditorClaim.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports